import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CreateIcon from "@mui/icons-material/Create";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import SearchIcon from "@mui/icons-material/Search";
import LinkIcon from "@mui/icons-material/Link";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import UpdateIcon from "@mui/icons-material/Update";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import VisibilityIcon from "@mui/icons-material/Visibility";
import WarningIcon from "@mui/icons-material/Warning";
import AddIcon from "@mui/icons-material/Add";
import { Icon } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PersonalVideoIcon from "@mui/icons-material/PersonalVideo";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PrintIcon from "@mui/icons-material/Print";
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MergeIcon from '@mui/icons-material/Merge';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon  from '@mui/icons-material/Error';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import SyncIcon from "@mui/icons-material/Sync";
import { TopicOutlined } from "@mui/icons-material";
import { Edit } from "@mui/icons-material";
import { Source } from "@mui/icons-material";
import { FolderSharedOutlined } from "@mui/icons-material";
import { Home } from "@mui/icons-material";
import {Folder} from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import UploadIcon from '@mui/icons-material/Upload';
import FolderIcon from '@mui/icons-material/Folder';
import { Upload } from "@mui/icons-material";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import { IconButton } from "@mui/material";
import PushPinIcon from "@mui/icons-material/PushPin";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";

export {
  OpenInNewIcon,
  CreateIcon,
  CloseIcon,
  UploadFileIcon,
  DeleteIcon,
  VisibilityIcon,
  WarningIcon,
  AddIcon,
  RemoveIcon,
  Icon,
  ArrowForwardIosIcon,
  PersonalVideoIcon,
  ArrowDownward,
  ArrowUpward,
  ArrowDropDownIcon,
  ArrowDropUpIcon,
  SearchIcon,
  LinkIcon,
  ContentCopyIcon,
  UpdateIcon,
  AccountBoxIcon,
  ArrowForwardIcon,
  VisibilityOffIcon,
  ChecklistIcon,
  ExpandMoreIcon,
  PrintIcon,
  FacebookIcon,
  GoogleIcon,
  MoreVertIcon,
  MergeIcon,
  CheckIcon,
  ManageAccountsIcon,
  WarningAmberIcon,
  ErrorIcon,
  SyncIcon,
  ErrorOutlineIcon,
  AttachMoneyOutlinedIcon,
  TopicOutlined,
  Edit,
  Source,
  FolderSharedOutlined,
  Home,
  Folder,
  DownloadIcon,
  UploadIcon,
  FolderIcon,
  Upload,
  UndoIcon,
  RedoIcon,
  IconButton,
  PushPinIcon,
  PushPinOutlinedIcon
};


export const ICON_MAP = {
  VisibilityIcon,
  PersonalVideoIcon,
  SearchIcon,
  VisibilityOffIcon,
  ManageAccountsIcon,
  AttachMoneyOutlinedIcon,
};